import { render, staticRenderFns } from "./PaywallSimpleFeaturesList.vue?vue&type=template&id=5fc1a13e&scoped=true&"
import script from "./PaywallSimpleFeaturesList.vue?vue&type=script&lang=ts&"
export * from "./PaywallSimpleFeaturesList.vue?vue&type=script&lang=ts&"
import style0 from "./PaywallSimpleFeaturesList.vue?vue&type=style&index=0&id=5fc1a13e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc1a13e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5fc1a13e', component.options)
    } else {
      api.reload('5fc1a13e', component.options)
    }
    module.hot.accept("./PaywallSimpleFeaturesList.vue?vue&type=template&id=5fc1a13e&scoped=true&", function () {
      api.rerender('5fc1a13e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/components/PaywallSimpleFeaturesList.vue"
export default component.exports